import * as React from 'react';
import {FunctionComponent, useMemo} from 'react';
import {Bucket} from '../Utils/Bucket';
import {formatDistance} from '../../Support/Formatting/formatDistance';
import {formatDuration} from '../../Support/Formatting/formatDuration';
import {classNames} from '../../Support/classNames';
import {PartialWorkout} from '../../../Models/PartialWorkout';
import {StatisticsProvider} from '../../../Business/StatisticsProvider';
import {SummaryBarChart} from '../Charts/SummaryBarChart';
import {DateRange} from '../../../Domain/DateRange';
import {SummaryPieChart} from '../Charts/SummaryPieChart';

interface OwnProps {
    partialWorkouts: PartialWorkout[];
    compact?: boolean;
    dateRange?: DateRange;
    className?: string;
}

export const PartialWorkoutsSummary: FunctionComponent<OwnProps> = ({
    partialWorkouts,
    dateRange,
    className,
    compact,
}) => {
    const statisticsProvider = useMemo(() => StatisticsProvider.create(partialWorkouts), [partialWorkouts]);

    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Summary</h5>
            </div>
            <div className="card-body d-flex flex-column gap-3">
                <Bucket value={formatDistance(statisticsProvider.totalDistance)} label="Total distance" />
                <Bucket value={formatDuration(statisticsProvider.totalDuration)} label="Total time" />
                <SummaryBarChart partialWorkouts={partialWorkouts} dateRange={dateRange} />
                {!compact && <SummaryPieChart partialWorkouts={partialWorkouts} dateRange={dateRange} />}
            </div>
        </div>
    );
};
